export enum DataSchemaFieldRowType {
  Default = 'default',
  InputDefinition = 'input-definition',
  OutputDefinition = 'output-definition'
}
